export default __webpack_public_path__ + "images/home-icon-blue.a332ff558b86a7ee0fc0c605ac7613c0.png";